// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pathFill":"_clMsG","dash":"-GTenm"};